"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetShiftDefaultDetails = void 0;
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const useSortedContracts_1 = require("@app/util/hooks/useSortedContracts");
const moment_1 = __importDefault(require("moment"));
const useGetShiftDefaultDetails = () => {
    const employees = (0, store_1.useRootSelector)((state) => Object.values(state.employees).filter((emp) => !emp.external));
    const positions = (0, store_1.useRootSelector)((state) => state.positions);
    const shifts = (0, store_1.useRootSelector)((state) => state.shifts);
    return (data = {}) => {
        const selectedEmployee = employees.find((emp) => emp.id === data.userId);
        const selectedShift = shifts.find((sh) => sh.id === data.id);
        const { activeContracts } = (0, useSortedContracts_1.parseContracts)(selectedEmployee?.contracts ?? [], data.period?.start);
        const activeContract = activeContracts.find((c) => c.type === selectedEmployee?.contractType);
        let _defaultPosition = data.positionId;
        if (!(0, util_1.isValue)(_defaultPosition)) {
            const positionsOnWS = [...(Array.isArray(positions) ? positions : [])]
                .filter((p) => !p.archived)
                .map((p) => {
                return { ...p, employeesCount: 0 };
            });
            Object.values(employees).forEach((ee) => {
                ;
                (ee.positions || []).forEach((p) => {
                    const idx = positionsOnWS.findIndex((pow) => pow.id === p.id);
                    if (idx >= 0) {
                        positionsOnWS[idx].employeesCount = positionsOnWS[idx].employeesCount + 1;
                    }
                });
            });
            positionsOnWS.sort((a, b) => {
                return a.employeesCount < b.employeesCount ? 1 : -1;
            });
            const userId = selectedEmployee?.id;
            if ((0, util_1.isValue)(userId)) {
                const _currentEmployee = employees.find((emp) => emp.id === userId);
                // if the shift is assigned to someone, pick one position that is assigned to that user (this will prioritize the position that's assigned to most other people, since we sorted that array before)
                if ((0, util_1.isDefined)(_currentEmployee) && _currentEmployee?.positions?.length) {
                    const p = positionsOnWS.find((p) => _currentEmployee.positions?.some((eePos) => eePos.id === p.id));
                    if (p)
                        _defaultPosition = p.id;
                }
                // if we still don't have a pick by now, it means the user doesn't have any position, in which case we just pick the most assigned position on the WS, even though the user doesn't have it
                if (!_defaultPosition) {
                    if (positionsOnWS?.length)
                        _defaultPosition = positionsOnWS[0].id;
                }
            }
            else {
                // if the shift is unassigned, just pick the most used position on WS
                if (positionsOnWS?.length)
                    _defaultPosition = positionsOnWS[0].id;
            }
        }
        return {
            // @ts-expect-error
            agenda: selectedShift?.agenda ?? ((0, maybe_unwrap_1.unwrapMaybe)(data.agenda?.filter(util_1.isValue)) || []),
            attendanceApproved: selectedShift?.attendanceApproved ?? (0, maybe_unwrap_1.unwrapMaybe)(data.attendanceApproved),
            contractId: selectedShift?.contractId ??
                (0, maybe_unwrap_1.unwrapMaybe)(data.contractId) ??
                (0, maybe_unwrap_1.unwrapMaybe)(activeContract?.id),
            contractType: selectedShift?.contractType ?? (0, maybe_unwrap_1.unwrapMaybe)(data.contractType),
            // @ts-expect-error
            customAttributes: selectedShift?.customAttributes ?? data.customAttributes?.filter(util_1.isValue),
            idealSkill: selectedShift?.idealSkill ?? (0, maybe_unwrap_1.unwrapMaybe)(data.idealSkill),
            localityId: selectedShift?.localityId ?? (0, maybe_unwrap_1.unwrapMaybe)(data.localityId),
            note: selectedShift?.note ?? (0, maybe_unwrap_1.unwrapMaybe)(data.note),
            overTime: selectedShift?.overTime ?? (0, maybe_unwrap_1.unwrapMaybe)(data.overTime),
            // @ts-expect-error
            pauses: selectedShift?.pauses ??
                ((0, util_1.isValue)(data.pauses) ? data.pauses.filter(util_1.isValue) : []),
            pausesFixed: selectedShift?.pausesFixed ??
                ((0, util_1.isValue)(data.pausesFixed) ? data.pausesFixed : false),
            period: {
                start: (0, util_1.isValue)(data.period?.start)
                    ? (0, moment_1.default)(data.period?.start)
                    : (0, moment_1.default)().set({ hours: 8 }).startOf('hour'),
                end: (0, util_1.isValue)(data.period?.end)
                    ? (0, moment_1.default)(data.period?.end)
                    : (0, moment_1.default)().set({ hours: 16, minutes: 30 }).startOf('minute'),
            },
            position: (0, maybe_unwrap_1.unwrapMaybe)(_defaultPosition),
            standBy: (0, maybe_unwrap_1.unwrapMaybe)(data.standBy),
            // @ts-expect-error
            standByActivities: (0, maybe_unwrap_1.unwrapMaybe)(data.standByActivities?.filter(util_1.isValue)),
            user: (0, maybe_unwrap_1.unwrapMaybe)(data.userId),
        };
    };
};
exports.useGetShiftDefaultDetails = useGetShiftDefaultDetails;
